// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_addForm__bF6Qf","formControl":"addForm_formControl__HAT68","list":"addForm_list__oOUSF","btnWrpper":"addForm_btnWrpper__6gMEx"};